import { render, staticRenderFns } from "./StakingForm.vue?vue&type=template&id=3187450d&scoped=true"
import script from "./StakingForm.vue?vue&type=script&lang=js"
export * from "./StakingForm.vue?vue&type=script&lang=js"
import style0 from "./StakingForm.vue?vue&type=style&index=0&id=3187450d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187450d",
  null
  
)

export default component.exports